const ProjectsSlider = ($) => {
	$(document).ready(function () {
		$("#programs-slider").slick({
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: 5,
			slidesToScroll: 1,
			prevArrow: '<div class="slick-prev slick-arrow"></div>',
			nextArrow: '<div class="slick-next slick-arrow"></div>',
			responsive: [
				{
					breakpoint: 1600,
					settings: {
						slidesToShow: 3.5,
					},
				},
				{
					breakpoint: 1400,
					settings: {
						slidesToShow: 3,
					},
				},
				{
					breakpoint: 1000,
					settings: {
						slidesToShow: 2.5,
					},
				},
				{
					breakpoint: 700,
					settings: {
						slidesToShow: 2,
						arrows: false,
					},
				},
				{
					breakpoint: 550,
					settings: {
						slidesToShow: 1.5,
						arrows: false,
					},
				},
				{
					breakpoint: 450,
					settings: {
						slidesToShow: 1.3,
						arrows: false,
					},
				},
				{
					breakpoint: 355,
					settings: {
						slidesToShow: 1.1,
						arrows: false,
					},
				},
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			],
		});
	});
};

export default ProjectsSlider;
